/* eslint-disable react-hooks/exhaustive-deps */
import styled from "@emotion/styled";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, Link, Radio, RadioGroup, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "../../../common/DataTable";
import { columnDefs } from "./columnDefs";
import { apiRequest } from "../../../common/common";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { useSelector } from "react-redux";
import { LoadingPage } from "../../../common/LoadingPage";
import FilterPanel from "./FilterPanel";
import { ContentCopyOutlined, DeleteOutline } from "@mui/icons-material";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { countries, CurrencyJSON, FundingSource, ProjectFields, projectStatus, projectType } from "../../../common/const";
import moment from "moment/moment";
import EditProject from "./EditProject";
import ImageIcon from '@mui/icons-material/Image';
import ImageModal from "../Catalog/ProductModule/ImageModel";
import ColumnPanel from "../../../common/ColumnPanel";

const DividerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  minHeight: 50
}));

const Cell = styled(TableCell)({
  padding: '8px 8px 8px 20px'
});

export default function Project() {
  const navigate = useNavigate();
  const { roles, user } = useSelector(state => state.users);
  const isUser = roles.find((a) => a.id === user?.role_id);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchingText, setSearchText] = useState(null);
  const [rowsPerPage, setRowPerPage] = useState(localStorage.getItem('projectPageSize') || 10);
  const [productColumn, setProductColumn] = useState(columnDefs);
  const [settingData, setSettingData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [filterType, setFilterType] = useState(localStorage.getItem('filterType') || 'All');
  const [projectId, setProjectId] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [data, setData] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [selectedProject, setSelectedProject] = useState(localStorage.getItem('projectData') ? localStorage.getItem('projectData') : null);
  const [copyOpen, setCopyOpen] = useState(false);
  const [reset, setReset] = useState('no');
  const [copyObj, setCopyObj] = useState(null);

  const onPaginationChanged = (event) => {
    if (event.api) {
      const newPageSize = event.api.paginationGetPageSize();
      localStorage.setItem('projectPageSize', newPageSize);
      setRowPerPage(newPageSize);
    }
  };

  const updatedColumns = useMemo(() => {
    let column = productColumn;
    if (column.length > 0) {
      return column?.map((col) => {
        switch (col.field) {
          case 'name':
            return {
              ...col,
              flex: 1,
              minWidth: 150,
              cellRenderer: (params) => {
                if (params?.data && !params?.data?.is_deleted) {
                  return (
                    <Link
                      style={{ textDecoration: 'none', cursor: 'pointer' }}
                      onClick={() => {
                        setSelectedProject(params?.data?.project_id);
                        localStorage.setItem('projectData', params?.data?.project_id);
                      }}
                    >

                      {params?.data?.name || '--'}
                    </Link>
                  )
                } else {
                  return (
                    <span style={{ color: 'red' }}>{params?.data?.name || '--'}</span>
                  )
                }
              },
            }
          case 'images':
            return {
              ...col,
              minWidth: 100,
              cellRenderer: (params) => {
                if (params?.data) {
                  if (params?.data?.images?.[0]?.sortUrl) {
                    return (
                      <Box sx={{ height: '100%', width: '30px', display: 'flex', justifyContent: 'center' }}>
                        <img
                          src={params?.data?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : ''}
                          style={{ height: '100%', cursor: 'pointer' }}
                          onClick={() => {
                            setImageOpen(true);
                            setImageSrc(params?.data?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${params?.data?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : '');
                          }}
                          alt="img"
                        />
                      </Box>
                    );
                  }
                  return (
                    <ImageIcon style={{ color: 'lightgray' }} />
                  );
                }
                return '';
              },
            };

          case 'type':
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {projectType.find((a) => a.value === params?.data?.type)?.name || '--'}
                </span>
              ),
            }
          case 'status':
            return {
              ...col,
              flex: 1,
              minWidth: 100,
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {params?.data?.is_deleted ? 'InActive' : projectStatus.find((a) => a.value === params?.data?.status)?.name || '--'}
                </span>
              ),
            }
          case 'room_count':
            return {
              ...col,
              flex: 1,
              minWidth: 80,
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {params?.data?.total_rooms || 0}
                </span>
              ),
            }
          case 'created_at':
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {moment(params?.data?.created_at).format('DD-MMM-YYYY')}
                </span>
              ),
            }
          case 'project_no':
            return {
              ...col,
              flex: 1,
              minWidth: 100,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {params?.data?.project_no}
                </span>
              ),
            }
          case 'target_occupation':
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => params?.data && (
                <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>
                  {moment(params?.data?.target_occupation).format('DD-MMM-YYYY') || '--'}
                </span>
              ),
            }
          case 'current_phase':
            return {
              ...col,
              flex: 1,
              minWidth: 220,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.is_certificate_need) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Certificate of need/initial budget</span>
                } else if (params?.data?.is_construction_document_enable) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Construction Document (CD)</span>
                } else if (params?.data?.is_contract_admin) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Contract Administration</span>
                } else if (params?.data?.is_design_development_enable) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Design Development (DD)</span>
                } else if (params?.data?.is_schematic_design_enable) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Schematic Design (SD)</span>
                } else if (params?.data?.is_programing_enable) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>Programming</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>--</span>;
                }
              },
            }
          case 'teamid':
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.teamid) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{params?.data?.teamid}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>--</span>;
                }
              },
            }
          case 'client_organization':
            return {
              ...col,
              minWidth: 225,
              width: 225,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.client_organization) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{params?.data?.client_organization}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>--</span>;
                }
              },
            }
          case 'department_count':
            return {
              ...col,
              flex: 1,
              minWidth: 120,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.["_count"]) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{params?.data?.["_count"]?.departments}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>0</span>
                }
              },
            }
          case 'combined_room_count':
            return {
              ...col,
              flex: 1,
              minWidth: 100,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.project_rooms) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{params?.data?.total_rooms + params?.data?.inactive_rooms}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>0</span>
                }
              },
            }
          case 'inactive_room_count':
            return {
              ...col,
              flex: 1,
              minWidth: 90,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.inactive_rooms) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{params?.data?.inactive_rooms}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>0</span>
                }
              },
            }
          case 'funding_source':
            return {
              ...col,
              minWidth: 135,
              width: 135,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.funding_source) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{FundingSource.find((a) => a.value === params?.data?.funding_source)?.name}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>--</span>
                }
              },
            }
          case 'total_construction_cost':
            return {
              ...col,
              minWidth: 185,
              width: 185,
              cellStyle: (params) => {
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.total_construction_cost) {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>{`${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.total_construction_cost)}`}</span>
                } else {
                  return <span style={{ color: !params?.data?.is_deleted ? 'black' : 'red' }}>--</span>
                }
              },
            }
          case 'total_approved_budget':
            return {
              ...col,
              minWidth: 185,
              width: 185,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.total_approved_budget) {
                  return `${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.total_approved_budget)}`
                } else {
                  return '--';
                }
              },
            }
          case 'total_project_budget':
            return {
              ...col,
              minWidth: 165,
              width: 165,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.actual_budget) {
                  return `${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.actual_budget)}`
                } else {
                  return '--';
                }
              },
            }
          case 'project_variance':
            return {
              ...col,
              minWidth: 175,
              width: 175,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.project_variance) {
                  return `${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.project_variance)}`
                } else {
                  return '--';
                }
              },
            }
          case 'created_by':
            return {
              ...col,
              minWidth: 105,
              width: 105,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.createduser) {
                  return `${params?.data?.createduser?.first_name} ${params?.data?.createduser?.last_name !== null ? params?.data?.createduser?.last_name : ''}`
                } else {
                  return '--';
                }
              },
            }
          case 'total_tax':
            return {
              ...col,
              flex: 1,
              minWidth: 130,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                return `${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.total_tax)}`
              },
            }
          case 'sub_total':
            return {
              ...col,
              flex: 1,
              minWidth: 150,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                return `${CurrencyJSON.find((a) => a.value === params?.data?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.sub_total)}`
              },
            }
          case 'city':
            return {
              ...col,
              flex: 1,
              minWidth: 130,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.address?.city) {
                  return params?.data?.address?.city
                } else {
                  return '--';
                }
              },
            }
          case 'state':
            return {
              ...col,
              flex: 1,
              minWidth: 105,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.address?.state) {
                  return params?.data?.address?.state
                } else {
                  return '--';
                }
              },
            }
          case 'country':
            return {
              ...col,
              flex: 1,
              minWidth: 105,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.address?.country) {
                  return countries.find((a) => a.code?.toLowerCase() === params?.data?.address?.country)?.name
                } else {
                  return '--';
                }
              },
            }

          case 'taxable_option':
            return {
              ...col,
              minWidth: 80,
              width: 80,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.taxable_option) {
                  return JSON.parse(params?.data?.taxable_option)?.includes('Freight') ? 'Yes' : "No"
                } else {
                  return 'No';
                }
              },
            }
          case 'taxable_option_1':
            return {
              ...col,
              minWidth: 62,
              width: 62,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.taxable_option) {
                  return JSON.parse(params?.data?.taxable_option)?.includes('Fees') ? 'Yes' : "No"
                } else {
                  return 'No';
                }
              },
            }
          case 'taxable_option_2':
            return {
              ...col,
              flex: 1,
              minWidth: 100,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.taxable_option) {
                  return JSON.parse(params?.data?.taxable_option)?.includes('Installation') ? 'Yes' : "No"
                } else {
                  return 'No';
                }
              },
            }
          case 'taxable_option_3':
            return {
              ...col,
              minWidth: 85,
              width: 85,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data?.taxable_option) {
                  return JSON.parse(params?.data?.taxable_option)?.includes('Storage') ? 'Yes' : "No"
                } else {
                  return 'No';
                }
              },
            }
          case 'is_tax_exempt':
            return {
              ...col,
              flex: 1,
              minWidth: 80,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data) {
                  return params?.data?.is_tax_exempt ? 'Yes' : "No"
                } else {
                  return 'No';
                }
              },
            }
          case 'owner':
            return {
              ...col,
              flex: 1,
              minWidth: 80,
              cellStyle: (params) => {
                if (params?.data?.is_deleted) {
                  return {
                    color: 'red'
                  }
                }
                return {
                  background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                };
              },
              cellRenderer: (params) => {
                if (params?.data) {
                  return `${params?.data?.owner?.first_name} ${params?.data?.owner?.last_name !== null ? params?.data?.owner?.last_name : ''}`
                } else {
                  return 'No';
                }
              },
            }
          default:
            return col;
        }
      });
    }
    return column;
  }, [productColumn]);

  const getData = async () => {
    try {
      setDataLoading(true)
      const response = await apiRequest('get', `/user-view?userId=${user?.user_id}&type=project&pageNo=1&pageSize=50`);
      const { data } = response.data;
      if (data?.length > 0) {
        if (data?.find((a) => a.is_pinned === true)?.columns) {
          setProductColumn(data?.find((a) => a.is_pinned === true)?.columns);
        }
        setSettingData(data);
      } else {
        setSettingData([]);
      }
      setDataLoading(false);
    } catch (error) {
      setDataLoading(false);
      showNotification(error?.response?.data.error || error.message, 'error');
    }
  }

  useEffect(() => {
    if (user?.user_id) {
      getData();
    }
  }, [user?.user_id]);

  const onGridReady = useCallback((params) => {
    if (params?.api) {
      const { api, searchingText, filters } = params;
      const filter = filters;
      setGridApi(api);
      setDataLoading(true);
      const dataSource = {
        rowCount: null,
        getRows: async (params) => {
          const sortModel = params?.sortModel[0];
          const sortBy = {
            column: sortModel?.colId || '',
            order: sortModel?.sort || '',
          };
          if (user?.organization?.organization_id) {
            const url = [
              `/project/list/${user?.organization?.organization_id}?`,
              `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
              `pageSize=${rowsPerPage}`,
              `filterType=${filterType}`,
              filter?.types?.length > 0 ? `type=${filter.types}` : '',
              filter?.status?.length > 0 ? `status=${filter.status}` : '',
              filter?.fundingSource?.length > 0 ? `fundingSource=${filter.fundingSource}` : '',
              filter?.isDeleted === 'yes' || filter?.isDeleted === 'no' ? `isDeleted=${filter?.isDeleted === 'yes' ? true : ''}` : '',
              sortBy?.column ? `sortBy=${sortBy.column}` : '',
              sortBy?.order ? `sortOrder=${sortBy.order}` : '',
              searchingText ? `searchText=${encodeURIComponent(searchingText)}` : ''
            ].filter(Boolean).join('&');
            try {
              const response = await apiRequest('get', `${url}`);
              const { data, total_count } = response.data;
              let lastRow = -1;
              if (data?.length <= total_count) {
                lastRow = total_count;
              }
              params.successCallback(data, lastRow);
              setDataLoading(false);
            } catch (error) {
              setDataLoading(false);
              showNotification(error?.response?.data.error || error.message, 'error');
            }
          }
        },
      };
      api.setGridOption("datasource", dataSource);
      setTimeout(() => {
        const node = api.getRenderedNodes();
        if (!node?.[0]?.displayed) {
          api.showNoRowsOverlay();
        }
      }, 5000);
    }
  }, [rowsPerPage, filterType]);


  const getInitialData = async (pageNo, searchingText, filters) => {
    if (user?.organization?.organization_id) {
      if (filters) {
        localStorage.setItem('projectfilters', JSON.stringify(filters));
      }
      const filter = localStorage.getItem('projectfilters') ? JSON.parse(localStorage.getItem('projectfilters')) : filters;
      const url = [
        `/project/list/${user?.organization?.organization_id}?`,
        `pageNo=${pageNo}`,
        `pageSize=100`,
        `filterType=${filterType}`,
        filter?.types?.length > 0 ? `type=${filter.types}` : '',
        filter?.status?.length > 0 ? `status=${filter.status}` : '',
        filter?.fundingSource?.length > 0 ? `fundingSource=${filter.fundingSource}` : '',
        filter?.isDeleted === 'yes' || filter?.isDeleted === 'no' ? `isDeleted=${filter?.isDeleted === 'yes' ? true : ''}` : '',
        searchingText ? `searchText=${encodeURIComponent(searchingText)}` : ''
      ].filter(Boolean).join('&');
      try {
        const response = await apiRequest('get', `${url}`);
        const { data } = response.data;
        setData(data);
        setDataLoading(false);
      } catch (error) {
        setDataLoading(false);
        showNotification(error?.response?.data.error || error.message, 'error');
      }
    }
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      onGridReady({
        api: gridApi,
      });
    }
    return () => {
      isMounted = false;
    };
  }, [rowsPerPage, filterType]);

  useEffect(() => {
    getInitialData(1, searchingText);
  }, [filterType, searchingText]);

  useEffect(() => {
    if (productColumn?.length > 0 && gridApi) {
      const columnState = gridApi?.getColumnState()?.map(state => {
        const columnConfig = productColumn.find((c) => c.colId === state.colId || c.field === state.colId);
        if (columnConfig) {
          if (columnConfig.pinned !== state.pinned) {
            state.pinned = columnConfig.pinned ? columnConfig.pinned : null;
          }
        }

        return state;
      });
      gridApi?.applyColumnState({ state: columnState });
      gridApi?.refreshHeader();
    }
  }, [productColumn]);

  const toolPanel = useMemo(() => [
    {
      id: 'custom1',
      labelDefault: 'Columns',
      iconKey: "columns",
      toolPanel: ColumnPanel,
      width: 450,
      toolPanelParams: {
        columns: productColumn,
        setColumns: (column) => {
          setProductColumn(column);
        },
        settingData,
        fetchData: () => {
          if (user?.user_id) {
            getData();
          }
        },
        type: "project",
        defaultVisibleColumns: columnDefs,
        columnOrder: productColumn,
      }
    },
    isUser?.code !== 'orgGuestUser' && {
      id: 'custom2',
      iconKey: "filter",
      labelDefault: 'Filters',
      toolPanel: FilterPanel,
      width: 300,
      toolPanelParams: {
        applyFilter: (filters) => {
          setRowPerPage(localStorage.getItem('projectPageSize') || 10);
          onGridReady({
            api: gridApi,
            filters
          });
          getInitialData(1, searchingText, filters);
        }
      }
    },
  ], [gridApi, settingData, productColumn]);

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
      {imageOpen && (
        <ImageModal
          imageSrc={imageSrc}
          open={imageOpen}
          onClose={() => {
            setImageOpen(false);
            setImageSrc('');
          }}
        />
      )}
      <DividerHeader />
      <Dialog open={deleteOpen} fullWidth maxWidth="xs">
        <DialogContent>Are you sure you want to permanently delete this one? It cannot be recovered.</DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="secondary"
            onClick={() => {
              setProjectId(null);
              setDeleteOpen(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={async () => {
              try {
                setDataLoading(true);
                let response = await apiRequest('delete', `/project/${projectId}`);
                if (response?.data) {
                  setDataLoading(false);
                  showNotification(response?.data?.message, 'success');
                  setProjectId(null);
                  setDeleteOpen(false);
                  onGridReady({
                    api: gridApi
                  });
                  getInitialData(1, searchingText);
                }
              } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={copyOpen} fullWidth maxWidth="sm">
        <DialogTitle>Copy Project</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Do you want to reset below fields?</Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              value={reset}
              name="radio-buttons-group"
              onChange={(e) => {
                setReset(e.target.value);
              }}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
          <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                <TableHead>
                  <TableRow>
                    <Cell>Fields</Cell>
                    <Cell>Comment</Cell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ProjectFields.map((a) => (
                    <TableRow>
                      <Cell>
                        {a.field}
                      </Cell>
                      <Cell>
                        {a?.description}
                      </Cell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="secondary"
            onClick={() => {
              setCopyOpen(false);
              setCopyObj(null);
              setReset('no');
            }}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={async () => {
              setDataLoading(true);
              try {
                const response = await apiRequest('post', '/project/copy', {
                  project_id: copyObj.project_id,
                  organization_id: copyObj?.organization_id,
                  is_reset: reset === 'yes' ? true : false
                });
                if (response?.data) {
                  getInitialData(1, searchingText);
                  onGridReady({
                    api: gridApi
                  });
                  setReset('no');
                  setCopyOpen(false);
                  setCopyObj(null);
                  setDataLoading(false);
                  showNotification(`Project copied successfully`, 'success');
                }
              } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
              }
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container>
        {selectedProject === null && (
          <Grid item xs={12} sm={12} md={3} lg={3} style={{ height: '87vh', overflow: 'auto', borderRight: '1px solid lightgray' }}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: 'space-between', margin: '0px 3px 6px 3px' }}>
              <Typography variant='h6' style={{ fontWeight: 'bold' }}>Projects</Typography>
              <Box style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant={filterType === 'All' ? 'contained' : 'outlined'}
                  size="small"
                  style={{
                    borderRadius: 20,
                    fontSize: '10px'
                  }}
                  onClick={() => {
                    localStorage.setItem('filterType', 'All');
                    setFilterType('All')
                  }}
                >
                  All Projects
                </Button>
                <Button
                  variant={filterType === 'my' ? 'contained' : 'outlined'}
                  size="small"
                  style={{
                    marginLeft: 5,
                    borderRadius: 20,
                    fontSize: '10px'
                  }}
                  onClick={() => {
                    localStorage.setItem('filterType', 'my');
                    setFilterType('my')
                  }}
                >
                  My Projects
                </Button>
              </Box>
            </Box>
            {data?.map((d) => (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '5px',
                  alignItems: 'center',
                  border: '1px solid lightgray',
                  margin: '3px',
                  borderRadius: '8px',
                  background: 'lightgray',
                }}
              >
                <Box style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                  {d.owner_ids.includes(user?.user_id) ? (
                    <Tooltip title="Remove From Favourite">
                      <StarIcon
                        color="primary"
                        style={{ cursor: 'pointer' }}
                        onClick={async () => {
                          const ownerIds = d?.owner_ids;
                          const index = ownerIds.findIndex((a) => a === user?.user_id);
                          if (index > -1) {
                            ownerIds.splice(index, 1);
                          }
                          setDataLoading(true);
                          try {
                            const response = await apiRequest('put', `/project/${d.project_id}`, {
                              owner_ids: ownerIds,
                              name: d?.name,
                              organization_id: d?.organization_id,
                              owner_id: d?.owner_id
                            });
                            if (response?.data) {
                              getInitialData(1, searchingText);
                              setDataLoading(false);
                            }
                          } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                          }
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Add In Favourite">
                      <StarBorderIcon
                        color="primary"
                        style={{ cursor: 'pointer' }}
                        onClick={async () => {
                          const ownerIds = d?.owner_ids;
                          ownerIds.push(user?.user_id);
                          setDataLoading(true);
                          try {
                            const response = await apiRequest('put', `/project/${d.project_id}`, {
                              owner_ids: ownerIds,
                              name: d?.name,
                              organization_id: d?.organization_id,
                              owner_id: d?.owner_id
                            });
                            if (response?.data) {
                              getInitialData(1, searchingText);
                              setDataLoading(false);
                            }
                          } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                          }
                        }}
                      />
                    </Tooltip>
                  )}
                  <Typography
                    variant="body2"
                    onClick={() => {
                      if (!d?.is_deleted) {
                        setSelectedProject(d.project_id);
                        localStorage.setItem('projectData', d?.project_id);
                      }
                    }}
                    style={{
                      cursor: !d?.is_deleted ? 'pointer' : 'auto',
                      color: d?.is_deleted ? 'red' : ''
                    }}
                    color="primary"
                  >
                    {d.name}
                  </Typography>
                </Box>
                {isUser?.code !== 'orgGuestUser' && (
                  <Box style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title={d?.is_deleted === false ? 'Active' : 'In Active'}>
                      <Switch
                        size="small"
                        checked={d?.is_deleted === false}
                        onChange={async (e) => {
                          setDataLoading(true);
                          try {
                            const response = await apiRequest('patch', `/project/set-delete-status/${d.project_id}`, {
                              isDeleted: e.target.checked === true ? false : true
                            });
                            if (response?.data) {
                              getInitialData(1, searchingText);
                              onGridReady({
                                api: gridApi
                              })
                              setDataLoading(false);
                              showNotification(response?.data?.message, 'success');
                            }
                          } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                          }
                        }}
                      />
                    </Tooltip>
                    {!d?.is_deleted && (
                      <Tooltip title="Copy Project">
                        <ContentCopyOutlined
                          color="primary"
                          style={{ cursor: 'pointer' }}
                          onClick={async () => {
                            setCopyOpen(true);
                            setCopyObj({
                              project_id: d.project_id,
                              organization_id: d?.organization_id
                            });
                          }}
                        />
                      </Tooltip>
                    )}
                    {['mvedasMasterAdmin', 'mvedasAdmin', 'OrgAdmin'].includes(isUser?.code) && (
                      <Tooltip title="Permanent Delete">
                        <DeleteOutline
                          color="secondary"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setDeleteOpen(true);
                            setProjectId(d?.project_id);
                          }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>
            ))}
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={selectedProject === null ? 9 : 12} lg={selectedProject === null ? 9 : 12} pl={selectedProject === null ? 1 : 0}>
          {selectedProject === null && (
            <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <TextField
                size="small"
                id="outlined-search"
                type="text"
                placeholder="Search Results"
                style={{
                  background: '#ebeaea',
                  height: 39
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    searchingText && ( // Show the clear icon only if there's text in the field
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setSearchText('');
                            onGridReady({
                              api: gridApi,
                              searchingText: ''
                            });
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    )
                  ),
                }}
                value={searchingText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    onGridReady({
                      api: gridApi,
                      searchingText: e.target.value
                    });
                  }
                }}
              />
              {user?.role_id !== 5 && (
                <Button
                  size="Medium"
                  variant="contained"
                  onClick={() => {
                    navigate('/app/projects/create')
                  }}
                  startIcon={<AddIcon />}
                  style={{
                    marginLeft: 10,
                    height: 39
                  }}
                >
                  Create
                </Button>
              )}
            </Box>
          )}
          {selectedProject !== null ? (
            <EditProject
              selectedProject={selectedProject}
              setSelectedProject={setSelectedProject}
              getInitialData={getInitialData}
            />
          ) : (
            <DataTable
              height="80vh"
              columnDefs={updatedColumns}
              rowsPerPage={rowsPerPage}
              onGridReady={onGridReady}
              toolPanel={toolPanel}
              onPaginationChanged={onPaginationChanged}
              modelType="infinite"
              onColumnMoved={() => {
                setProductColumn(gridApi.getAllGridColumns().map((column) => column.getColDef()));
              }}
            />
          )}
        </Grid>
      </Grid>
      {selectedProject === null && (
        <Divider />
      )}
    </Box>
  )
}